import React, {useEffect} from "react";
import 'components-jqueryui';
import $ from "jquery";
import 'select2';
import feather from "feather-icons";
import {SEARCH_COLLECTION_URL} from "../../api";
import {capitalize} from "../../utils/capitalize";
import {useSelector} from "react-redux";
import formatNumber from "../../utils/formatNumber";
import {organisation, transaction} from "../../api/app";
import cogoToast from "cogo-toast";
const jQuery = window.$;

let addresses = [];
let amount = 0;

const Wizard = ({ onFinish }) => {

    const auth = useSelector((state) => state.auth.user);
    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        $(function () {
            'use strict';
            feather.replace();
        });

        jQuery('#wizard2').steps({
            headerTag: 'h3',
            bodyTag: 'section',
            autoFocus: true,
            titleTemplate: '<span class="number">#index#</span> <span class="title">#title#</span>',
            onStepChanging: function (event, currentIndex, newIndex) {
                if(currentIndex < newIndex) {
                    // Step 1 form validation
                    if(currentIndex === 0) {
                        let orgForm = $("#organisation-form").parsley();
                        if(orgForm.isValid()) {
                            return true;
                        } else {
                            orgForm.validate();
                        }
                    }
                    // Always allow step back to the previous step even if the current step is not valid.
                } else {
                    return true;
                }
            },
            onFinished: function (event, currentIndex) {
                // Final validation before submit
                let acctForm = $("#account-form").parsley();
                if (acctForm.isValid()) {

                    let data = {
                        name: $("#name").val(),
                        type: $("#type").val(),
                        reg_number: $("#reg-number").val(),
                        contact_number: $("#contact-number").val(),
                        email:  $("#email").val(),
                        org_address:  $("#street-address").val(),
                        country:  $("#country-select2").val()[0],
                        apps: [
                            {
                                domain:  $("#domain").val(),
                                policy:  $("#policy-select2").val()[0],
                            }
                        ],
                        account_holder: {
                            name:  $("#person-name").val(),
                            position:  $("#position").val(),
                            mobile_number:  $("#mobile-number").val(),
                            email:  $("#person-email").val(),
                            password:  $("#password").val(),
                        }
                    }

                    const options = {
                        position: "top-right",
                        hideAfter: 0
                    };

                    let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                    organisation("post", data).then((result) => {
                        if(!result.error) {
                            hide();
                            cogoToast.success("Organisation successfully created.", {position: "top-right"});
                            onFinish();
                        } else {
                            hide();
                        }
                    });
                } else {
                    acctForm.validate();
                    return false;
                }
            }
        });

        initializePolicySearch();
        initializeCountrySearch();

        return () => {
            amount = 0;
            const wizard = jQuery('#wizard2');
            if(wizard.data('steps')) {
                wizard.steps('destroy');
            }
        };
    }, []);

    $(function () {
        $(document).on("change", "#address", function () {
            let $productSelect = $('#product-select2');
            $productSelect.empty();

            if($(this).val()) {
                $productSelect.prop("disabled", false);
            } else {
                $productSelect.prop("disabled", true);
            }
        });

        $(document).on("change", "#total-month", function (e) {
            let total_month = e.target.value;
            let total_bin = $("#total-bin").val();
            $("#total-amount").text(`${auth.user.country.currency.symbol}${formatNumber(amount * total_month * total_bin)}`);
        });

        $(document).on("change", "#total-bin", function (e) {
            let total_month = $("#total-month").val();
            let total_bin = e.target.value;
            $("#total-amount").text(`${auth.user.country.currency.symbol}${formatNumber(amount * total_month * total_bin)}`);
        });

        return () => {
            $(document).off("change", "#total-month");
            $(document).off("change", "#total-bin");
            $(document).off("change", "#address");
        };
    });

    const initializePolicySearch = () => {
        let modalOrganisation = $('#modalOrganisation');
        $('#policy-select2').select2({
            placeholder: 'Select policy',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalOrganisation,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "policy"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const initializeCountrySearch = () => {
        let modalOrganisation = $('#modalOrganisation');
        $('#country-select2').select2({
            placeholder: 'Select country',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalOrganisation,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "country"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    return(
        <div id="wizard2">
            <h3>Organisation</h3>
            <section className="parsley-style-1">
                <p className="mg-b-20">Fill all the information below.</p>
                <form id="organisation-form">
                    <div className="row row-sm">
                        <div id="nameWrapper" className="form-group parsley-input col-md-12">
                            <label>Name<span className="tx-danger">*</span></label>
                            <input id="name" type="text" className="form-control"
                                   placeholder="Enter organisation name"
                                   autoComplete="none"
                                   data-parsley-class-handler="#nameWrapper" required/>
                        </div>

                        <div id="typeWrapper" className="form-group parsley-input col-md-12">
                            <label>Type<span className="tx-danger">*</span></label>
                            <select className="custom-select" id="type" required>
                                <option value="" disabled selected>Select</option>
                                <option value="business">Business</option>
                                <option value="ngo">Non-Governmental Organization</option>
                                <option value="government">Government</option>
                            </select>
                        </div>

                        <div id="regWrapper" className="form-group parsley-input col-md-12">
                            <label>Registration Number<span className="tx-danger">*</span></label>
                            <input id="reg-number" type="text" className="form-control"
                                   placeholder="Enter company registration #"
                                   autoComplete="none"
                                   data-parsley-class-handler="#regWrapper" required/>
                        </div>

                        <div id="contactWrapper" className="form-group parsley-input col-md-12">
                            <label>Contact Number<span className="tx-danger">*</span></label>
                            <input id="contact-number" type="number" className="form-control"
                                   placeholder="Enter contact number"
                                   autoComplete="none"
                                   data-parsley-class-handler="#contactWrapper" required/>
                        </div>

                        <div id="emailWrapper" className="form-group parsley-input col-md-12">
                            <label>Email Address<span className="tx-danger">*</span></label>
                            <input id="email" type="text" className="form-control"
                                   placeholder="Enter email address"
                                   autoComplete="none"
                                   data-parsley-class-handler="#emailWrapper" required/>
                        </div>

                        <div id="addressWrapper" className="form-group parsley-input col-md-12">
                            <label>Street Address<span className="tx-danger">*</span></label>
                            <input id="street-address" type="text" className="form-control"
                                   placeholder="Enter location address"
                                   autoComplete="none"
                                   data-parsley-class-handler="#addressWrapper" required/>
                        </div>

                        <div id="domainWrapper" className="form-group parsley-input col-md-12">
                            <label>Domain<span className="tx-danger">*</span></label>
                            <select className="custom-select" id="domain" required>
                                <option value="" disabled selected>Select</option>
                                <option value="collector">Collector</option>
                                <option value="authority">Authority</option>
                            </select>
                        </div>

                        <div id="policyWrapper" className="form-group parsley-input col-md-12">
                            <div className="d-flex justify-content-between">
                                <label>Policy<span className="tx-danger">*</span></label>
                            </div>
                            <select className="form-control" id="policy-select2" data-width="100%"
                                    multiple="multiple"
                                    data-parsley-class-handler="#policyWrapper"
                                    data-parsley-errors-container="#policyWrapper"
                                    autoComplete="off"
                                    required
                            >
                            </select>
                        </div>

                        <div id="countryWrapper" className="form-group parsley-input col-md-12">
                            <div className="d-flex justify-content-between">
                                <label>Country<span className="tx-danger">*</span></label>
                            </div>
                            <div className="parsley-select">
                                <select className="form-control form-select" id="country-select2" data-width="100%"
                                        multiple="multiple"
                                        data-parsley-class-handler="#countryWrapper"
                                        data-parsley-errors-container="#countryWrapper"
                                        autoComplete="off"
                                        required>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
            <h3>Account Holder</h3>
            <section className="parsley-style-1">
                <p>You are creating a login account for this organisation. Please fill in all the details below.</p>
                <form id="account-form">
                    <div className="row row-sm">
                        <div id="personNameWrapper" className="form-group parsley-input col-md-12">
                            <label>Person Name<span className="tx-danger">*</span></label>
                            <input id="person-name" type="text" className="form-control"
                                   placeholder="Enter person full name"
                                   autoComplete="none"
                                   data-parsley-class-handler="#personNameWrapper" required/>
                        </div>

                        <div id="positionWrapper" className="form-group parsley-input col-md-12">
                            <label>Postition<span className="tx-danger">*</span></label>
                            <input id="position" type="text" className="form-control"
                                   placeholder="Enter position"
                                   autoComplete="none"
                                   data-parsley-class-handler="#positionWrapper" required/>
                        </div>

                        <div id="mobileNumberWrapper" className="form-group parsley-input col-md-12">
                            <label>Mobile Number<span className="tx-danger">*</span></label>
                            <input id="mobile-number" type="number" className="form-control"
                                   placeholder="Enter mobile number"
                                   autoComplete="none"
                                   data-parsley-class-handler="#mobileNumberWrapper" required/>
                        </div>

                        <div id="personEmailWrapper" className="form-group parsley-input col-md-12">
                            <label>Email Address<span className="tx-danger">*</span></label>
                            <input id="person-email" type="text" className="form-control"
                                   placeholder="Enter account email"
                                   autoComplete="none"
                                   data-parsley-class-handler="#personEmailWrapper" required/>
                        </div>

                        <div id="passwordWrapper" className="form-group parsley-input col-md-12">
                            <label>Password<span className="tx-danger">*</span></label>
                            <input id="password" type="text" className="form-control"
                                   placeholder="Enter password"
                                   autoComplete="none"
                                   data-parsley-class-handler="#passwordWrapper" required/>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    )
}

export default Wizard;
